<template>
  <div class="user-item pa-1" :class="{ 'grey lighten-3': selected }">
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <template v-if="user.profile_pic">
          <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" />
        </template>
        <template v-else>
          <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
        </template>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title>{{ user.first_name + ' ' + user.last_name }}</v-list-tile-title>
        <v-list-tile-sub-title class="caption grey--text text--lighten-1">{{
          dayLeft(user.lastreply_time)
        }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <!-- <v-icon color="red lighten-1">info</v-icon> -->
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['value', 'selected'],
  data: function() {
    return {
      user: this.value,
      hasNewMessage: false
    }
  },
  filters: {
    time: function(date) {
      if (typeof date === 'string') {
        date = moment(date)
      }
      return date.format('h:mm A')
    }
  },
  mounted: function() {},
  methods: {
    imgError: function(event, el) {
      // console.log('not load')
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function(replytime) {
      var lastreply = moment(replytime)
      var currentDate = moment()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + this.$t('Hours')
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + this.$t('Minutes')
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + this.$t('Seconds')
      }
      return time
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.user = this.value
      if (newVal.lastreply_time != oldVal.lastreply_time) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    },
    selected: function(newVal, oldVal) {}
  }
}
</script>

<style lang="scss" scoped>
.user-item {
  .active {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue